import React, { useCallback, useContext, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import NotificationHub from './NotificationHub';

const NotificationContext = React.createContext();
export const useNotify = () => useContext(NotificationContext);

function NotificationProvider({ children }) {
  const ref = useRef(null);

  const success = useCallback(msg => ref.current({ type: 'success', msg }), []);
  const error = useCallback(msg => ref.current({ type: 'error', msg }), []);
  const info = useCallback(msg => ref.current({ type: 'info', msg }), []);

  const [nofityMethods] = useState({ success, error, info });

  return (
    <NotificationContext.Provider value={nofityMethods}>
      {children}
      <NotificationHub>
        {add => {
          ref.current = add;
        }}
      </NotificationHub>
    </NotificationContext.Provider>
  );
}

NotificationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NotificationProvider;
